module.exports = __webpack_public_path__ + "media/images/emblems/Heitenried-coat_of_arms-a2a61f2e4f8554eacd437cefca2a608c.svg";